import type { IDocumentGroupCrumb } from '../types'

import { buildDocumentGroups } from './buildDocumentGroups'

interface IResolvedDocumentGroups {
  groups: ReturnType<typeof buildDocumentGroups>
  geoPath: IDocumentGroupCrumb[]
  isPartnerLevel: boolean
}

/** Skip geo levels with no choice, stopping at a split or the partner list. */
export const resolveDocumentGroups = (
  params: Parameters<typeof buildDocumentGroups>[0]
): IResolvedDocumentGroups => {
  const { geoPath } = params
  const groups = buildDocumentGroups(params)

  if (params.grouping !== 'geo') {
    return { groups, geoPath, isPartnerLevel: params.grouping === 'partner' }
  }

  if (groups.length !== 1) {
    return { groups, geoPath, isPartnerLevel: false }
  }

  const group = groups[0]
  const node = params.geoMapping.find((item) => item.itemId === group.id)
  if (!node || !params.geoMapping.some((item) => item.parentId === node.itemId)) {
    return {
      groups: buildDocumentGroups({ ...params, sections: group.sections, grouping: 'partner' }),
      geoPath,
      isPartnerLevel: true,
    }
  }

  const step: IDocumentGroupCrumb = { id: group.id, label: group.label, automatic: true }
  return resolveDocumentGroups({ ...params, geoPath: [...geoPath, step] })
}
